// extracted by mini-css-extract-plugin
export default {"section":"IJ9N86CgzxABehExPbP0"};